"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var R = _interopRequireWildcard(require("ramda"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var getAvailableFontFeatures = R.path(['availableFeatures']);
var isFontFeatureExist = function isFontFeatureExist(font, feature) {
  var availableFontFeatures = getAvailableFontFeatures(font);
  if (!availableFontFeatures) return false;
  return availableFontFeatures.includes(feature);
};
var getFontFeatureTag = function getFontFeatureTag(feature) {
  switch (feature) {
    case 'small-caps':
      return 'smcp';
    default:
      return null;
  }
};
var hasSimpleLetters = function hasSimpleLetters(word) {
  return word.search(/[a-z\s]/g) !== -1;
};
var groupWordCharactors = function groupWordCharactors(word) {
  var charactors = word.split('');
  var uprecaseString = '';
  var lowercaseString = '';
  var letterGroups = [];
  charactors.forEach(function (char, index) {
    if (hasSimpleLetters(char)) {
      lowercaseString += char;
      if (!charactors[index + 1] || !hasSimpleLetters(charactors[index + 1])) {
        letterGroups.push(lowercaseString);
        lowercaseString = '';
      }
      return;
    }
    if (!hasSimpleLetters(char)) {
      uprecaseString += char;
      if (!charactors[index + 1] || hasSimpleLetters(charactors[index + 1])) {
        letterGroups.push(uprecaseString);
        uprecaseString = '';
      }
    }
  });
  return letterGroups;
};
var processSmallCaps = function processSmallCaps(attributedString) {
  var string = attributedString.string,
    runs = attributedString.runs;
  var processRun = function processRun(run) {
    var start = run.start,
      end = run.end,
      attributes = run.attributes;
    var fontVariant = attributes.fontVariant,
      font = attributes.font;
    if (!['small-caps'].includes(fontVariant)) {
      return [run];
    }
    if (['small-caps'].includes(fontVariant) && isFontFeatureExist(font, getFontFeatureTag(fontVariant))) {
      return [run];
    }
    var stringChunck = string.substring(start, end);
    var words = stringChunck.split(/(?=[A-Z][a-z])|(?=[A-Z])/) || [];
    var stringStartIndex = start;
    var processWords = function processWords(word) {
      var stringFragments = [];
      var letterGroups = groupWordCharactors(word);
      letterGroups.forEach(function (chars) {
        if (hasSimpleLetters(chars)) {
          stringFragments.push({
            start: stringStartIndex,
            end: stringStartIndex + chars.length,
            attributes: attributes
          });
          stringStartIndex += chars.length;
          return;
        }
        stringFragments.push({
          start: stringStartIndex,
          end: stringStartIndex + chars.length,
          attributes: (0, _extends2.default)({}, attributes, {
            fontVariant: 'normal'
          })
        });
        stringStartIndex += chars.length;
      });
      return stringFragments;
    };
    return R.compose(R.reduce(function (acc, elem) {
      acc.push.apply(acc, elem);
      return acc;
    }, []), R.map(processWords))(words);
  };
  return R.assoc('runs', R.compose(R.reduce(R.concat, []), R.map(processRun))(runs))(attributedString);
};
var _default = exports.default = processSmallCaps;